










import { Component, Vue } from 'vue-property-decorator';
import HeaderError from '@/components/header/headerError.vue';
import Footer from '@/components/footer/footer.vue';
import LeftSidebarError from '@/components/leftSidebar/leftSidebarError.vue';
import Page from '@/views/E500.vue';

@Component({
  components: {
    HeaderError,
    Footer,
    LeftSidebarError,
    Page,
  },
})
export default class DefaultLayout extends Vue {
}
